import { LoadingButton } from '@mui/lab';
import { useClientDeleteUserToken, UserPersonalToken } from '@apono/client-app-sdk';

import ConfirmDialog from '@common/ui/ConfirmDialog';
import { useState } from 'react';

export default function TokensTableRowAction({ token }: { token: UserPersonalToken }) {
  const [confirmOpened, setConfirmOpen] = useState(false);
  const { deleteUserToken, isLoading } = useClientDeleteUserToken(token.id);

  return (
    <>
      <LoadingButton variant="outlined" size="small" onClick={() => setConfirmOpen(true)} loading={isLoading}>
        Delete
      </LoadingButton>
      <ConfirmDialog open={confirmOpened} onClose={() => setConfirmOpen(false)} onConfirm={deleteUserToken}>
        Are you sure you want to delete token?
      </ConfirmDialog>
    </>
  );
}
